export default "__VITE_ASSET__BHtTwueJ__"